// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__e80ht","loaderOuter":"PageOverlayLoader_loaderOuter__2OSvB"};